import { useTranslation } from '@lyearn/i18n';
import { EditFields } from '@/modules/corporate/modules/questions/fields/edit';
import { ViewFields } from '@/modules/corporate/modules/questions/fields/view';

import { QuizQuestionEditorProps } from './types';

const QuizQuestionEditor: React.FC<QuizQuestionEditorProps> = (props) => {
  const { question, error, viewMode, onChange, setNudgeState, isLocalizedContent } = props;

  const { t } = useTranslation();

  const { Editor } = EditFields[question.questionType!];
  const { getQuestionLabel } = ViewFields[question.questionType!];

  return (
    <Editor
      error={error?.type !== 'QuestionSettings' ? error : undefined}
      isLocalizedContent={isLocalizedContent}
      question={question}
      questionLabel={t(getQuestionLabel({ questionSubType: question.subType }))}
      setNudgeState={setNudgeState}
      viewMode={viewMode}
      onChange={onChange}
    />
  );
};

export default QuizQuestionEditor;
